module.exports = __webpack_public_path__ + "static/media/Screenshot_2.ec6da539.png";